exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".router-row{widht:500px;margin:20px}.myform{padding:15px;height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0dc1b752!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 100
// module chunks = 0